/**
 * @fileoverview Atom: shimmering placeholder for content still loading.
 * @module components/atoms/Skeleton
 */

import "./Skeleton.css"

/** Props accepted by {@link Skeleton}. */
export interface SkeletonProps {
	/** CSS width. Defaults to `100%`. */
	readonly width?: string
	/** CSS height. Defaults to `1em`. */
	readonly height?: string
	/** Corner radius. Defaults to `6px`. */
	readonly radius?: string
}

/**
 * Shimmering block standing in for content that has not arrived yet.
 *
 * @param props - Dimensions of the placeholder.
 * @returns The rendered placeholder, hidden from assistive technology: the
 *   loading state it is part of is announced by its container instead.
 *
 * @example
 * <Skeleton width="60%" height="20px" />
 */
export function Skeleton({
	width = "100%",
	height = "1em",
	radius = "6px",
}: SkeletonProps) {
	return (
		<span
			className="skeleton"
			style={{ width, height, borderRadius: radius }}
			aria-hidden="true"
		/>
	)
}
